import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import * as bootstrap from 'bootstrap';
import { NotificationCtlService } from '../api/services';
import { SessionService } from '../common/session.service';

@Component({
  selector: 'app-notification',
  imports: [ReactiveFormsModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css'
})
export class NotificationComponent {

  notifyForm:FormGroup;
  message='';
  messageColor='text-success';
  currentPartner:number=0;


  @ViewChild('fileNotify',{static:false}) fileNotify!:ElementRef;

  constructor( private notificationService:NotificationCtlService,
    private sessionService:SessionService
  ){
    this.notifyForm = new FormGroup({
      file: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
      idPartner: new FormControl('', Validators.required),
      object:new FormControl('', Validators.required),
      message: new FormControl('', Validators.required)
    });
  }

  onChangeFile(event:any) {
    
    if(event.target ==null){
      this.notifyForm.patchValue({ file: null});
    }else {
    const file =event.target.files[0];
    this.notifyForm.patchValue({ file: file});
    this.notifyForm.patchValue({status:'OK'});
    }
  }
  onSendNotifyFile(){
     console.log('envoi fichier');
      this.notificationService.loadNotifyFile(
        this.notifyForm.value.file,
        this.notifyForm.value.object,
        this.notifyForm.value.message
       
        
  ).subscribe({
        next:()=>{
          console.log('charge ok');

          this.notifyForm.reset();
          this.messageColor ='text-success';
          this.message ='Traitement du fichier en cours. Un mail vous sera envoyé à la fin du traitement';
          this.resetLoadForm();
  
          const elt =document.getElementById('loadFileResult');
                   const modAdd = new bootstrap.Modal(elt!!);
                   modAdd.show();
  
  
        },
        error:(err: HttpErrorResponse)=>{
          let resp =JSON.parse(err.error);
          console.log("erss"+resp.message);
          this.message = resp.message;
          this.messageColor ='text-danger';
          this.notifyForm.patchValue({ file: ''});
          this.resetLoadForm();

          const elt =document.getElementById('loadFileResult');
                   const modAdd = new bootstrap.Modal(elt!!);
                   modAdd.show();
        }
      })
  
    }
    ngOnInit(): void {
    
    let sess = this.sessionService.getSessionInfo();
    this.currentPartner =sess.partner?.id!!;
    this.notifyForm.controls['idPartner'].setValue(sess.partner?.id!!);
    console.log('reload')
   
  }

    resetLoadForm(){
    this.fileNotify.nativeElement.value='';
  }

}
